import { useCallback, useMemo } from "react";
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router";
import { VerifyEmailForm } from "@app/components/organisms/verify-email-form";

type VerifyEmailLocationState = {
  email?: string;
  statusMessage?: string;
};

export function VerifyEmailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const state = (location.state ?? null) as VerifyEmailLocationState | null;
  const queryEmail = searchParams.get("email")?.trim() ?? "";

  const email = useMemo(() => {
    return state?.email?.trim() || queryEmail;
  }, [state, queryEmail]);
  const initialStatusMessage = state?.statusMessage?.trim() ?? "";

  const handleConfirmed = useCallback(() => {
    navigate("/login", {
      replace: true,
      state: { banner: "Email verified — please sign in." },
    });
  }, [navigate]);

  const handleStartOver = useCallback(() => {
    navigate("/signup", { replace: true });
  }, [navigate]);

  if (!email) {
    return <Navigate to="/signup" replace />;
  }

  return (
    <section className="events-page events-auth-page">
      <div className="events-auth-card events-auth-card--page">
        <VerifyEmailForm
          email={email}
          initialStatusMessage={initialStatusMessage}
          onConfirmed={handleConfirmed}
          onStartOver={handleStartOver}
          headingAs="h1"
        />
      </div>
    </section>
  );
}
